// extracted by mini-css-extract-plugin
export default {"root":"_1aSY-","left-aligned":"_1Sqey","leftAligned":"_1Sqey","right-aligned":"_15lor","rightAligned":"_15lor","heading":"EyYQc","postfix":"tu2y_"};